import { atomFamily } from "recoil";

import { INITIAL_CALENDAR_DROPDOWN_VALUE } from "../../constants";
import { TopCalendarMode } from "../../enums";
import { DatesUnit, RydeUiUnit } from "../../models";

export const topCalendarDatesAtomFamily = atomFamily<
  DatesUnit | undefined,
  RydeUiUnit
>({
  key: "topCalendarDatesAtomFamily",
  default: undefined,
});

export const topCalendarModeAtomFamily = atomFamily<
  TopCalendarMode,
  RydeUiUnit
>({
  key: "topCalendarModeAtomFamily",
  default: INITIAL_CALENDAR_DROPDOWN_VALUE,
});
